// extracted by mini-css-extract-plugin
export default {"image":"imageItem_image__Mp9im","buttons":"imageItem_buttons__zgIMa","left":"imageItem_left__V7c8O","right":"imageItem_right__2E5em","none":"imageItem_none__k3UKh"};